export default {
  urlShareHistory: {},
  urlShareList: [],
}
